import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "io-mfe-ig-grouper-info" }

import DualPane from 'components/global-common/DualPane.vue';
import { useGrouperStore } from 'stores/grouper-store';
import { ref, Ref } from 'vue';
import { storeToRefs } from 'pinia';
import DrgDisplay from 'components/grouper-common/DrgDisplay.vue';
import AutoSaveBanner from 'components/grouper-common/AutoSaveBanner.vue';

export interface Props {
  enableDualGrouping?: boolean,
  showApr?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperInfo',
  props: {
    enableDualGrouping: { type: Boolean, default: true },
    showApr: { type: Boolean, default: false }
  },
  emits: ["secondary-expanded"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const expandSecondary: Ref<boolean> = ref(props.showApr)
const grouperStore = useGrouperStore();
const {primaryDRG, secondaryDRG} = storeToRefs(grouperStore);

const onSecondaryExpanded = (value: boolean) => {
  grouperStore.changeDrgDrawerState(value);
  expandSecondary.value = value;
  emit('secondary-expanded', expandSecondary.value)
  return expandSecondary.value;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DualPane, {
      horizontal: "",
      vertical: "",
      disable: "",
      beforeClass: "drg-pane",
      afterClass: "drg-pane",
      separatorClass: "",
      expanded: props.showApr,
      secondaryVisible: props.enableDualGrouping,
      dark: "",
      onSecondaryExpanded: onSecondaryExpanded
    }, {
      primary: _withCtx(() => [
        _createVNode(DrgDisplay, {
          "drg-info": _unref(primaryDRG),
          "is-apr": !_unref(grouperStore).isPrimaryDrgMs
        }, null, 8, ["drg-info", "is-apr"])
      ]),
      secondary: _withCtx(() => [
        _createVNode(DrgDisplay, {
          "drg-info": _unref(secondaryDRG),
          "is-apr": _unref(grouperStore).isPrimaryDrgMs
        }, null, 8, ["drg-info", "is-apr"])
      ]),
      _: 1
    }, 8, ["expanded", "secondaryVisible"]),
    _createVNode(AutoSaveBanner)
  ]))
}
}

})